// extracted by mini-css-extract-plugin
export default {"notpage":"NotFoundPage_notpage__uEBWA","title":"NotFoundPage_title__hegjI","back":"NotFoundPage_back__uZQLs"};